import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

const LEVELS = {
  above: ["Au-dessus de la moyenne", "tone-rose", TrendingUp],
  average: ["Dans la moyenne", "tone-mint", Minus],
  below: ["En dessous de la moyenne", "tone-sky", TrendingDown],
};

export const Verdict = ({ b, testid, className }) => {
  if (!b) return null;
  const [label, tone, Icon] = LEVELS[b.level];
  return (
    <span className={cn("tone-chip inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold", tone, className)}
      title={`Repère indicatif CASHMY : ${b.basis}`} data-testid={testid}>
      <Icon className="h-3 w-3" />{label}{b.level !== "average" && ` (${b.pct > 0 ? "+" : ""}${b.pct} %)`}
    </span>
  );
};
